/**
 * Format words as sentence case (capitalise first letter, rest lowercase for words >= 4 chars).
 * @param {string} value - Input string
 * @returns {string|undefined} Formatted string or undefined if no words
 */
export function formatWordsAsSentences(value) {
  const words = value?.split(/\s+/);

  if (!words?.length) {
    return undefined;
  }

  const formattedWords = words.map((word) => {
    const hasNumericOnFirstFourChar = word.match(/^([^\d]{4})/);
    if (word.length >= 4 && hasNumericOnFirstFourChar) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
    return word;
  });

  return formattedWords.join(' ');
}
